
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class SearchInput extends Vue {
  display: boolean = true;
  @Prop({ default: 'Button' }) SearchType!: string;
  @Prop({ default: '请输入关键字' }) placeholder!: string;
  @Prop({ default: '#366ed8' }) buttonBg!: string;

  InputData(e: any) {
    this.$emit('fetchSearch', e.target.value);
  }
  onSubmit(e: any) {
    this.$emit('startSearch');
    this.display = false;
  }
  ChangeDisplay() {
    this.display = true;
  }
}
